export const saveRFP = async (userInfo, documentData, selectedRFP, setSelectedRFP, setIsModalOpen, setModalType, setModalSize, setModalTitle, setModalDescription, setModalConfirmButtonText, setModalOnConfirm, setModalOnCancel) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/rfp/saveRFP`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
        body: JSON.stringify({
            _id: selectedRFP,
            userId: userInfo._id,
            documentData: documentData,
        }),
    });
    const data = await response.json();
    if (response.ok) {
        setSelectedRFP(data.id);
        setIsModalOpen(true)
        setModalType('alert');
        setModalSize('medium')
        setModalTitle('RFP Saved');
        setModalDescription('Your Request for Proposal (RFP) document has been saved successfully!');
        setModalConfirmButtonText('OK');
        setModalOnConfirm(()=>()=>setIsModalOpen(false))
        setModalOnCancel(()=>()=> setIsModalOpen(false))
    } else {
        console.error("Error saving RFP:", data.message);
    }
};